// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnvironmentOutlinedSvg from "@fishx/icons-svg/es/asn/EnvironmentOutlined";
import FishxIcon from '../components/FishxIcon';

var EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentOutlinedSvg
  }));
};

EnvironmentOutlined.displayName = 'EnvironmentOutlined';
export default React.forwardRef(EnvironmentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EnvironmentOutlined.js
// module id = 2612
// module chunks = 0